export default __webpack_public_path__ + "static/media/12.99bb1bf4.jpg";